import { AiOutlineLock } from "react-icons/ai";

const LockedOverlay = ({ show = true, children }) => {
  if (!show) return null;

  return (
    <div className="absolute inset-0 bg-gray-500/60 backdrop-blur-sm flex items-center justify-center z-30 rounded-xl">
      <div className="text-center text-white p-6">
        <AiOutlineLock className="text-4xl mx-auto mb-3" />
        {children}
      </div>
    </div>
  );
};

export default LockedOverlay;
